/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import _ from "lodash"
import angular from "angular"

angular
  .module("uCountitUiApp")
  .controller(
    "StoreGroupOverviewCtrl",
    function (
      $scope,
      $rootScope,
      $state,
      $stateParams,
      DateTimeSrv,
      SelectorSrv,
      Auth,
      HeaderSrv,
      me,
      UtilSrv
    ) {
      $scope.orgTemplate = "storegroup"
      $scope.me = me
      HeaderSrv.fetchCurrentCompany().then((company) => ($scope.company = company))

      $scope.orgType = $stateParams.orgType
      $scope.orgId = $stateParams.id
      $scope.pageOptions = {
        sampling: "day",
        referenceDay: undefined,
        content: "overview",
      }

      $scope.useFootfall = false
      $scope.useFace = false
      $scope.useHeatmap = false

      $scope.displayName = UtilSrv.getDisplayStoreGroupName

      const init = () =>
        SelectorSrv.getOrganizationInfo($stateParams.orgType, $stateParams.id)
          .then(function (orgInfo) {
            $scope.currentOrg = orgInfo.store
            $scope.timezone = orgInfo.timezone
            $scope.stores = orgInfo.stores

            $scope.useFootfall = orgInfo.features.footfall
            $scope.useFace = orgInfo.features.face
            $scope.useHeatmap = orgInfo.features.heatmap || orgInfo.features.dwellmap
            $scope.useFaceCountOnly = orgInfo.useFaceCountOnly

            $scope.noFeatures = true
            return _.forEach(orgInfo.features, function (feature) {
              if (feature === true) {
                return ($scope.noFeatures = false)
              }
            })
          })
          .then(
            () => $scope.$broadcast("init-date-search", $scope.timezone),

            function (err) {
              if (err) {
                console.error(err)
              }
              return $state.go("default")
            }
          )

      return angular.element(() => init())
    }
  )
